import { useT } from "@/i18n/LangProvider";

export default function Ticker() {
  const { t } = useT();
  const items = t("ticker") || [];
  const all = Array.isArray(items) ? [...items, ...items, ...items, ...items] : [];

  return (
    <div data-testid="ticker" className="ticker">
      <div className="ticker-track">
        {all.map((it, i) => (
          <span key={i} className="ticker-item">
            {it} <span className="text-[color:var(--gold)]/60 ml-4">·</span>
          </span>
        ))}
      </div>
    </div>
  );
}
